var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "86px",
    viewBox: "0 0 66 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Document_1743069",
    transform: "translate(-17.000000, -1.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 0.637820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0.36222 C0.9246,0.36219 -0.0008,1.46131 -8.8817842e-16,2.36222 L-8.8817842e-16,84.3622 C0.0001,85.4094 0.9528,86.3621 2,86.3622 L64.000001,86.3622 C65.047201,86.3621 65.999901,85.4094 66.000001,84.3622 L66.000001,20.36222 C66.000001,19.82977 65.785001,19.29912 65.406301,18.92472 L47.406301,0.92472 C47.034201,0.56473 46.517801,0.35819 46.000001,0.36222 L2,0.36222 Z M4,4.36222 L44.000001,4.36222 L44.000001,20.36222 C44.000101,21.40939 44.952801,22.36212 46.000001,22.36222 L62.000001,22.36222 L62.000001,82.3622 L4,82.3622 L4,4.36222 Z M48.000001,7.17472 L59.187501,18.36222 L48.000001,18.36222 L48.000001,7.17472 Z M12,34.36222 C10.8954,34.36222 10,35.25762 10,36.36222 C10,37.46682 10.8954,38.36222 12,38.36222 L54.000001,38.36222 C55.104601,38.36222 56.000001,37.46682 56.000001,36.36222 C56.000001,35.25762 55.104601,34.36222 54.000001,34.36222 L12,34.36222 Z M12,50.3622 C10.8954,50.3622 10,51.2576 10,52.3622 C10,53.4668 10.8954,54.3622 12,54.3622 L54.000001,54.3622 C55.104601,54.3622 56.000001,53.4668 56.000001,52.3622 C56.000001,51.2576 55.104601,50.3622 54.000001,50.3622 L12,50.3622 Z M12,66.3622 C10.8954,66.3622 10,67.2576 10,68.3622 C10,69.4668 10.8954,70.3622 12,70.3622 L54.000001,70.3622 C55.104601,70.3622 56.000001,69.4668 56.000001,68.3622 C56.000001,67.2576 55.104601,66.3622 54.000001,66.3622 L12,66.3622 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e53e394a216316d362dfa6f0499fe108.svg";
export { ForwardRef as ReactComponent };